import { cn } from "@/lib/utils";

import { type ClaimTypeName, claimTypeBadgeClasses, getClaimTypeDisplayName } from "../lib/claim-types";

interface BadgeClaimTypeProps {
  name: ClaimTypeName;
  emoji?: boolean;
  textOnly?: boolean;
  className?: string;
}

/** Port of BadgeClaimType.vue. */
export function BadgeClaimType({ name, emoji = false, textOnly, className }: BadgeClaimTypeProps) {
  if (textOnly) {
    return (
      <span className={cn("py-0.5 text-gray-700", className)}>
        {getClaimTypeDisplayName(name, { emoji })}
      </span>
    );
  }

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md px-2.5 py-0.5 text-xs font-medium capitalize ring-1 ring-inset",
        claimTypeBadgeClasses[name],
        className,
      )}
    >
      {getClaimTypeDisplayName(name, { emoji })}
    </span>
  );
}
